function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-421.71429-525.79074)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 432.71429,
    cy: 536.79071,
    r: 6,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.71429 528.79074a8 8.00001 0 0 0 -8 8 8 8.00001 0 0 0 8 8 8 8.00001 0 0 0 8 -8 8 8.00001 0 0 0 -8 -8m-3.29297 4l3.29297 3.29297 3.29297-3.29297.70703.70703-3.29297 3.29297 3.29297 3.29297-.70703.70703-3.29297-3.29297-3.29297 3.29297-.70703-.70703 3.29297-3.29297-3.29297-3.29297.70703-.70703",
    style: {
      fill: "#da4453"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.b8e9d2665ed4ec822007ddf9a98488c5.svg";
export { ForwardRef as ReactComponent };